import { z } from 'zod'

import { ApiLoginResponseSchema } from '@/ducks/auth/auth.types'

export const mapLoginResponse = (
  data: z.input<typeof ApiLoginResponseSchema>
) => ({
  token: data.token,
  authSource: data.authSource,
  id: data.store_id,
  type: data.store_type,
  storeName: data.store_name,
  currencyCode: data.currency_code,
  currencySymbol: data.currency_symbol,
  username: data.owner_name,
  avatar: data.store_avatar,
  availability: data.availability,
  usingCashCo: data.usingCashCo,
  storeLedgerWalletEnabled: Boolean(data.store_ledger_wallet_enabled ?? false),
  phoneNumber: data.phone_number,
  phoneCode: data.country_code
})
